"use client";

import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(useGSAP);
export default function Lacticiniosintro() {
  const container = useRef<HTMLDivElement>(null);
  const headlineWords = "Especialistas em Pulverização Industrial desde 1937.".split(" ");
  useGSAP(() => {
    const mm = gsap.matchMedia();
    mm.add("(prefers-reduced-motion: no-preference)", () => {
      gsap.set(".es-eyebrow", {
        y: -8
      });
      gsap.to(".es-eyebrow", {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out"
      });
      gsap.set(".es-word", {
        y: 24
      });
      gsap.to(".es-word", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        stagger: 0.04,
        ease: "power3.out",
        delay: 0.15
      });
      gsap.set(".es-body", {
        y: 16
      });
      gsap.to(".es-body", {
        opacity: 1,
        y: 0,
        duration: 0.72,
        ease: "power3.out",
        delay: 0.9
      });
      gsap.to(".es-bokeh", {
        xPercent: 3,
        duration: 22,
        ease: "sine.inOut",
        repeat: -1,
        yoyo: true
      });
      gsap.set(".es-bokeh", {
        opacity: 0
      });
      gsap.to(".es-bokeh", {
        opacity: 1,
        duration: 1.2,
        ease: "power2.out"
      });
    });
    mm.add("(prefers-reduced-motion: reduce)", () => {
      gsap.set([".es-eyebrow", ".es-word", ".es-body", ".es-bokeh"], {
        opacity: 1,
        y: 0
      });
    });
  }, {
    scope: container
  });
  return;
}